/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostTier1SimpleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABAElEQVR4nGNgGCzA3z/cwS8g4h4Ig9hUNdw3IDzN1z/8l19AxH8o/u3rH15OscGhoaFsfgERM6GG/vP1j2gHYRAbKjYTpIYsw318IkV8AyL2gQ3yD//u5xcWB5Pz9w8P9wuI+AqRizjiFRoqQZLh/v7hCn4BEQ9BBvj6hz/284swQVcDEgPLQXzy0Nc3VJFoC3wDwjdCXX4Mn+tAciA1YIcEhK8m2gK49/0ipAip9fYOlYYG1XNSLACnFlqpH7WAMBiNg0EQRP4Rz0nOaAHhX0ixYC0ZRcU6oi3wDopSIrWw8wqKkmcYNMU1XSoculSZDEgAVNH7+kfcAWGqV/qUAABqf+veVbu8EgAAAABJRU5ErkJggg==)
 */
export const BoostTier1SimpleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M13.05 1.4a1.59 1.59 0 0 0-2.1 0l-4.9 4A3.37 3.37 0 0 0 5 8v8c0 1.07.4 2.06 1.05 2.6l4.9 4c.65.53 1.45.53 2.1 0l4.9-4A3.37 3.37 0 0 0 19 16V8c0-1.07-.4-2.06-1.05-2.6l-4.9-4ZM12 3.12 7.32 6.95C7.25 7.01 7 7.35 7 8v8c0 .65.25 1 .32 1.05L12 20.88l4.68-3.83c.07-.06.32-.4.32-1.05V8c0-.65-.25-1-.32-1.05L12 3.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
